<label>
    <input type="checkbox" [checked]="checked$ | async" (click)="onChange($event)">
    <span class="label-content">
        <ng-content ></ng-content>
    </span>
    <span class="checkmark"></span>
</label>